export default "__VITE_ASSET__C4J05CI___"